(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/create-team/assets/javascripts/create-team.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/create-team/assets/javascripts/create-team.js');
"use strict";


const {
  selectCreateTeam
} = svs.components.marketplaceCompetition.services.selectors.createTeamSelector;
const {
  selectPlayerCompetitionById
} = svs.components.marketplaceCompetition.services.selectors.competitionSelectors;

const {
  playerCompetitionActions,
  createTeamActions
} = svs.components.marketplaceCompetition.services.actions;

const {
  ReactButton,
  ReactIcon,
  ReactPaper
} = svs.ui;
const {
  trackEvent
} = svs.components.analytics;
const {
  CreateTeam: CreateTeamShared
} = svs.components.marketplaceShared.createTeam;
const {
  Modal
} = svs.components.lbUi.modal;

const {
  FetchState,
  CompetitionType
} = svs.components.marketplaceCompetition.constants;

const {
  useCallback,
  useEffect
} = React;
const {
  useHistory
} = ReactRouterDOM;
const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  showDialogAction
} = svs.components.marketplaceCompetition.services.actions.dialogActions;
const {
  useCompetitionId
} = svs.components.marketplaceCompetition.competitionContext;
const {
  useCompetitionType,
  useCompetition
} = svs.components.marketplaceCompetition.services.hooks;
const {
  resolveCompetitionName
} = svs.components.marketplaceCompetition.helpers;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;

const resolveValidationError = teamName => {
  const invalidCharRegex = /[^A-ZÅÄÖa-zåäö0-9 -]/;
  let validationError = '';
  if (teamName) {
    if (teamName.trim().length > 25) {
      validationError = 'Max 25 tecken';
    } else if (teamName.trim().length === 1) {
      validationError = 'Minst 2 tecken';
    } else if (invalidCharRegex.test(teamName)) {
      validationError = 'Otillåtet tecken';
    }
  }
  return validationError;
};
const CreateTeam = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const competitionId = useCompetitionId();
  const competition = useCompetition(competitionId);
  const compType = useCompetitionType(competitionId);
  const playerCompetition = useSelector(state => selectPlayerCompetitionById(state, competitionId));
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const onCancel = () => {
    if (status === FetchState.Pending) {
      return;
    }
    const path = history.location.pathname;
    const newPath = path.slice(0, path.indexOf('skapa-lag'));
    history.replace("".concat(newPath.replace(/\/$/, ''), "?focus=create"));
  };
  const onInit = useCallback(() => {
    dispatch(createTeamActions.setCreateTeam({
      status: undefined,
      teamId: undefined
    }));
  }, [dispatch]);
  useEffect(onInit, [onInit]);

  const onCreated = (data, teamName) => {
    const {
      teamId
    } = data;
    dispatch(createTeamActions.setCreateTeam({
      teamName: undefined,
      error: undefined
    }));
    dispatch(showDialogAction({
      title: "".concat(teamName, " skapades!"),
      icon: 'checkmark',
      buttons: [{
        text: 'Okej'
      }]
    }));
    const newPath = "lag/".concat(teamId, "/bjud-in");
    history.replace(newPath);
  };
  const RulesAndTerms = () => {
    const {
      tipsSmRulesDocumentId,
      tipsEmRulesDocumentId,
      policyPersonalData
    } = svs.tipsen.data.competition || {};
    const rulesDocumentId = compType === CompetitionType.TipsEM ? tipsEmRulesDocumentId : tipsSmRulesDocumentId;
    return React.createElement("div", {
      className: "create-team-rules f-center"
    }, React.createElement("p", {
      className: "margin-bottom-2"
    }, "Genom att skapa eller g\xE5 med i ett lag godk\xE4nner du", ' ', React.createElement("a", {
      className: "qa-rules create-team-rules-link fc-sport-75",
      href: "/dokument/".concat(rulesDocumentId),
      rel: "noreferrer",
      target: "_blank"
    }, "regler och villkor f\xF6r ".concat(resolveCompetitionName(competition)))), React.createElement("p", null, "Information g\xE4llande", ' ', React.createElement("a", {
      className: "qa-rules-personal create-team-rules-link fc-sport-75",
      href: "/dokument/".concat(policyPersonalData),
      rel: "noreferrer",
      target: "_blank"
    }, "behandling av personuppgifter")));
  };
  const CreateTeamButtons = () => {
    const {
      teamName,
      status,
      error
    } = useSelector(state => selectCreateTeam(state));
    const validationError = resolveValidationError(teamName);
    const isCreateDisabled = Boolean(status === FetchState.Pending || !teamName || !teamName.trim() || (error === null || error === void 0 ? void 0 : error.resolvedMessage) || validationError);
    return React.createElement("div", {
      className: "create-team-button-container margin-top-2"
    }, React.createElement(ReactButton, {
      "aria-disabled": isCreateDisabled,
      className: ['create-team-button qa-create-team-button', isCreateDisabled ? 'disabled' : ''].join(' '),
      "data-testid": "qa-create-team-button",
      inverted: true,
      type: "submit"
    }, "Anm\xE4l laget"), !isSmall && React.createElement(ReactButton, {
      "aria-disabled": status === FetchState.Pending,
      "aria-label": "Avbryt anm\xE4lan av lag",
      className: ['create-team-button create-team-button-close'].join(' '),
      "data-testid": "qa-cancel-create-team-button",
      onClick: onCancel,
      transparent: true,
      type: "button"
    }, "St\xE4ng"));
  };
  const CreateTeamForm = () => {
    const {
      teamName,
      status,
      error
    } = useSelector(state => selectCreateTeam(state));
    const validationError = resolveValidationError(teamName);
    const isCreateDisabled = Boolean(status === FetchState.Pending || !teamName || !teamName.trim() || (error === null || error === void 0 ? void 0 : error.resolvedMessage));

    const handleCreate = async teamName => {
      if (isCreateDisabled) {
        return;
      }
      const _createTeam = () => dispatch(createTeamActions.createTeam({
        compType,
        competitionId,
        teamName: teamName.trim(),
        callback: (createError, data) => !createError && onCreated(data, teamName.trim())
      }));
      if (playerCompetition) {
        _createTeam();
      } else {
        var _dispatch;
        await ((_dispatch = dispatch(playerCompetitionActions.putParticipation({
          competitionId
        }))) === null || _dispatch === void 0 ? void 0 : _dispatch.unwrap());
        trackEvent({
          category: compType,
          action: 'joined competition',
          opt_label: 'Lag'
        });
        _createTeam();
      }
    };
    return React.createElement("div", {
      className: "competition-create-team "
    }, React.createElement(CreateTeamShared, {
      backendError: error === null || error === void 0 ? void 0 : error.resolvedMessage,
      history: history,
      infoMessage: "T\xE4nk p\xE5 att Svenska Spel har r\xE4tt att \xE4ndra ol\xE4mpliga lagnamn.",
      inverted: false,
      isLoading: status === FetchState.Pending,
      isSubmittable: status !== FetchState.Pending && teamName !== undefined,
      label: "Ange lagets namn",
      onHandleSubmit: name => isCreateDisabled ? null : handleCreate(name),
      onTeamNameChange: name => {
        dispatch(createTeamActions.setCreateTeam({
          teamName: name.replace(/\s\s+/g, ' '),
          error: undefined,
          status: undefined
        }));
      },
      subtitle: "N\xE4r du har anm\xE4lt ditt lag kan du bjuda in sl\xE4ktingar, v\xE4nner och kollegor.",
      teamName: teamName,
      title: "Anm\xE4l ett lag",
      validationError: validationError
    }, React.createElement(RulesAndTerms, null), React.createElement(CreateTeamButtons, null)));
  };
  const FixedFooter = () => React.createElement("div", {
    className: "create-team-footer bg-white padding-1"
  }, React.createElement(ReactButton, {
    "aria-label": "Avbryt anm\xE4lan av lag",
    block: true,
    onClick: onCancel,
    size: 300,
    transparent: true
  }, "St\xE4ng"));
  const content = () => React.createElement("div", {
    className: "create-team-page",
    "data-testid": "qa-create-team"
  }, React.createElement("div", {
    className: "create-team-center"
  }, React.createElement(ReactIcon, {
    icon: "contact-us",
    size: "700"
  })), React.createElement(CreateTeamForm, null), isSmall && React.createElement(FixedFooter, null));
  return isSmall ? React.createElement(Modal, {
    isOpen: true
  }, React.createElement("div", {
    className: "margin-top-2"
  }, content())) : React.createElement(ReactPaper, {
    branding: "sport",
    className: "create-team-bigger-container"
  }, content());
};

setGlobal('svs.components.marketplaceCompetition.createTeam', {
  CreateTeam,
  resolveValidationError
});

 })(window);